import React from 'react'
import { Route } from 'react-router-dom'
import MainTeamMember from '../Views/Web/TeamMemeber/MainTeamMember'
import { IndexTeam, TeamCreate, TeamEdit, TeamMain, Teamview } from '../Views/Web/TeamMemeber/Team/Index'
import { AvailabilityMain, IndexAvailability } from '../Views/Web/TeamMemeber/Availability/Index'

function TeamRoutes() {
  return (
    <Route path="teammember" element={<MainTeamMember />}>
        <Route path="team" element={<TeamMain/>} >
           <Route index element={<IndexTeam/>} />
           <Route path='create' element={<TeamCreate/>} />
           <Route path='edit/:teamEditId' element={<TeamEdit/>} />
           <Route path='view/:teamViewId' element={<Teamview/>} />
               
          </Route>
          <Route path="availability" element={<AvailabilityMain/>} >
           <Route index element={<IndexAvailability/>} />
           {/* <Route path='create' element={<CalendarCreate/>} />
           <Route path='edit/:calenderEditId' element={<CalendarEdit/>} />
           <Route path='view/:calenderViewId' element={<CalendarView/>} /> */}
          </Route>
          
          </Route>
  )
}

export default TeamRoutes